import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../../app";

interface DashboardFilterControl {
  key: string;
  label: string;
  placeholder: string;
  type: "select" | "text";
  options: { text: string; value: string }[];
}

interface DashboardFilterGroup {
  title: string;
  icon?: string;
  modifier: string;
  collapsed: boolean;
  controls: DashboardFilterControl[];
}

@Component({
    selector: "app-filter-dashboard",
    templateUrl: "./filter-dashboard.component.html",
    styleUrls: ["./filter-dashboard.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterDashboardComponent implements OnInit {
  private readonly unknownOmApproachValue = "Unknown";
  private readonly noApproachValue = "noApproach";

  filterGroups: DashboardFilterGroup[] = [];

  app = getApp((app) => {
    this.app = app;
  });

  constructor() {}

  ngOnInit() {
    this.filterGroups = this.getFilterGroups();
  }

  private getFilterGroups(): DashboardFilterGroup[] {
    return [
      {
        title: "General Filters",
        icon: "fas fa-sliders-h",
        modifier: "general",
        collapsed: false,
        controls: [
          this.createTextFilterControl("assembly", "Assembly", "Assembly"),
        ],
      },
      {
        title: "OM Filters",
        icon: "fas fa-fire",
        modifier: "om",
        collapsed: false,
        controls: [
          this.createFilterControl(
            "omApproach",
            this.app.field.getLabel(this.app.fieldId.thread.omApproach),
            this.app.fieldId.thread.omApproach,
            "All Approaches"
          ),
        ],
      },
      // {
      //   title: "RM Filters",
      //   icon: "fas fa-tachometer-alt",
      //   modifier: "rm",
      //   collapsed: false,
      //   controls: [],
      // },
      // {
      //   title: "Task Filters",
      //   icon: "fas fa-list-ul",
      //   modifier: "task",
      //   collapsed: false,
      //   controls: [
      //     this.createFilterControl(
      //       "department",
      //       "Department",
      //       this.app.fieldId.user.businessArea,
      //       "All Departments"
      //     ),
      //   ],
      // },
    ];
  }

  toggleGroup(group: DashboardFilterGroup) {
    group.collapsed = !group.collapsed;
  }

  applyFilters() {
    if (this.app.filterDashboard.isFilterDisabled()) {
      return;
    }

    this.app.filterDashboard.getSelectedFilters();
    this.app.filterDashboard.enableReset = true;
  }

  private createFilterControl(
    key: string,
    label: string,
    fieldId: string,
    placeholder: string
  ): DashboardFilterControl {
    return {
      key,
      label,
      placeholder,
      type: "select",
      options: this.getOptions(fieldId),
    };
  }

  private createTextFilterControl(
    key: string,
    label: string,
    placeholder: string
  ): DashboardFilterControl {
    return {
      key,
      label,
      placeholder,
      type: "text",
      options: [],
    };
  }

  private getOptions(fieldId: string) {
    try {
      const options = this.app.field.getOptionsAndTextsForASpecificField(fieldId);

      if (fieldId === this.app.fieldId.thread.omApproach) {
        return this.addUnknownOmApproachOption(options);
      }

      return options;
    } catch {
      return [];
    }
  }

  private addUnknownOmApproachOption(options: { text: string; value: string }[]) {
    const normalizedOptions = options.filter((option) => {
      const value = option.value.toLowerCase();

      return value === "proactive" || value === "reactive";
    });
    const noApproachOption = options.find((option) => {
      const value = option.value.toLowerCase();

      return value === this.noApproachValue.toLowerCase();
    });

    return [
      ...normalizedOptions,
      {
        text: noApproachOption?.text || "No approach selected",
        value: this.unknownOmApproachValue,
      },
    ];
  }
}
